import { render, staticRenderFns } from "./PEmoticonInput.vue?vue&type=template&id=1ba7b0de&"
import script from "./PEmoticonInput.vue?vue&type=script&lang=js&"
export * from "./PEmoticonInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports